import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, tap, filter, concatMap, of } from 'rxjs'
import { handleMessages } from '../modules/client/utilities'

export default {
  state: () => ({
    // for page used
    cmses: [],
    cmsCategories: [],
    selectedCms: null,
    selectedCmsSubCategory: null, // for select v-model used

    // for bottom menu
    bottomMenu: [],

    // for user tip
    userTips: [],
    exchangeRates: [],
    userTipCategory: null,

    // wc footer intro
    footerIntro: null,

    // wc sub menu list
    subMenu: null
  }),
  actions: {
    getCmses(context, { category, subCategory, locale, config }) {
      const { commit, dispatch } = context
      return from(
        dispatch('getCmsInfo', {
          category,
          subCategory,
          locale,
          config
        })
      )
        .pipe(
          tap(({ cmses, cmsCategories }) => {
            commit('CMSES', cmses)
            commit('CMS_CATEGORIES', cmsCategories)
          }),
          tap(({ selectedCms }) => {
            if (selectedCms) {
              dispatch('updateSelectedCms', selectedCms)
            } else {
              dispatch('initSelectedCms')
            }
          })
        )
        .toPromise()
    },
    /**
     * 直接 call api 並轉換資料格式後回傳 Promise
     * (可提供多筆 cms 使用)
     *
     * @param context
     * @param category
     * @param subCategory
     * @param locale
     * @param config
     * @returns {Promise<AxiosResponse<any>>}
     */
    getCmsInfo(context, { category, subCategory, locale, config }) {
      const { rootState } = context
      if (category) {
        config = {
          ...config,
          params: {
            category,
            languageCode: locale || rootState.locale,
            deviceType: !rootState.isMobile ? 'PC' : 'MOBILE'
          }
        }
      }
      return from(
        this.$axios.$get(
          `/webapi/system/getCmsInfo`,
          getAxiosConfig(context, config)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(data =>
            of(
              (data.data || []).map(item => ({
                ...item,
                content: !rootState.isMobile
                  ? item.pcContent
                  : item.mobileContent
              }))
            )
          ),
          concatMap(cmses =>
            of({
              cmses,
              cmsCategories: cmses.map(cms => ({
                title: cms.title,
                category: cms.subCategory,
                parentCategory: cms.category
              })),
              selectedCms: subCategory
                ? cmses.find(cms => subCategory === cms.subCategory)
                : cmses[0]
            })
          )
        )
        .toPromise()
    },
    getAllExchangeRate(context) {
      const { commit } = context
      return from(
        this.$axios.$post(
          `/webapi/payment/getAllExchangeRate`,
          {},
          getAxiosConfig(context, { timeout: 30 * 1000 })
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => commit('EXCHANGE_RATES', data || []))
        )
        .toPromise()
    },
    getBottomMenu(context, { category, locale, config }) {
      const { commit, rootState } = context
      if (category) {
        config = {
          ...config,
          params: {
            category,
            languageCode: locale || rootState.locale,
            deviceType: !rootState.isMobile ? 'PC' : 'MOBILE'
          }
        }
      }
      return from(
        this.$axios.$get(
          `/webapi/system/getCmsInfo`,
          getAxiosConfig(context, config)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(data =>
            of(
              (data.data || []).map(cms => ({
                title: cms.title,
                category: cms.subCategory
              }))
            )
          ),
          tap(bottomMenu => commit('BOTTOM_MENU', bottomMenu))
        )
        .toPromise()
    },
    getUserTips(context, { category, locale, config }) {
      const { commit, rootState } = context
      if (category) {
        config = {
          ...config,
          params: {
            category,
            languageCode: locale || rootState.locale,
            deviceType: !rootState.isMobile ? 'PC' : 'MOBILE'
          }
        }
      }
      return from(
        this.$axios.$get(
          `/webapi/system/getCmsInfo`,
          getAxiosConfig(context, config)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(data =>
            of(
              (data.data || []).map(item => ({
                ...item,
                content: !rootState.isMobile
                  ? item.pcContent
                  : item.mobileContent
              }))
            )
          ),
          tap(userTips => commit('USER_TIPS', userTips))
        )
        .toPromise()
    },
    initSelectedCms({ commit }) {
      commit('SELECTED_CMS', null)
      commit('SELECTED_CMS_SUB_CATEGORY', null)
      commit('headerModule/TITLE', null, { root: true })
    },
    updateSelectedCms({ state, commit }, payload) {
      commit('SELECTED_CMS', payload)
      commit('SELECTED_CMS_SUB_CATEGORY', state.selectedCms.subCategory)
      commit('headerModule/TITLE', state.selectedCms.title, { root: true })
    },
    getFooterIntro(
      context,
      { category = 'footer', subCategory = 'introduction', locale, config } = {
        category: 'footer',
        subCategory: 'introduction',
        config: {}
      }
    ) {
      const { commit, rootState } = context
      if (category) {
        config = {
          ...config,
          params: {
            category,
            subCategory,
            languageCode: locale || rootState.locale,
            deviceType: !rootState.isMobile ? 'PC' : 'MOBILE'
          }
        }
      }
      return from(
        this.$axios.$get(
          `/webapi/system/getCmsInfo`,
          getAxiosConfig(context, config)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(data =>
            of(
              (data.data || []).map(cms => ({
                content: !rootState.isMobile ? cms.pcContent : cms.mobileContent
              }))
            )
          ),
          concatMap(data =>
            of(
              data.length > 0
                ? data[0]
                : {
                    content: ''
                  }
            )
          ),
          tap(footerIntro => commit('FOOTER_INTRO', footerIntro))
        )
        .toPromise()
    },
    getSubMenu(context, { category, locale, config }) {
      const { state, commit, rootState } = context
      if (category) {
        config = {
          ...config,
          params: {
            category,
            languageCode: locale || rootState.locale,
            deviceType: !rootState.isMobile ? 'PC' : 'MOBILE',
            noContent: true
          }
        }
      }
      return from(
        this.$axios.$get(
          `/webapi/system/getCmsInfo`,
          getAxiosConfig(context, config)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          concatMap(data =>
            of(
              (data.data || []).map(cms => ({
                title: cms.title,
                subCategory: cms.subCategory
              }))
            )
          ),
          concatMap(data => {
            let subMenu = state.subMenu || {}
            subMenu = { ...subMenu, [category]: data }
            return of(subMenu)
          }),
          tap(subMenu => commit('SUB_MENU', subMenu))
        )
        .toPromise()
    }
  },
  mutations: {
    CMSES(state, payload) {
      state.cmses = payload
    },
    CMS_CATEGORIES(state, payload) {
      state.cmsCategories = payload
    },
    SELECTED_CMS(state, payload) {
      state.selectedCms = payload
    },
    SELECTED_CMS_SUB_CATEGORY(state, payload) {
      state.selectedCmsSubCategory = payload
    },

    BOTTOM_MENU(state, payload) {
      state.bottomMenu = payload
    },

    USER_TIPS(state, payload) {
      state.userTips = payload
    },
    EXCHANGE_RATES(state, payload) {
      state.exchangeRates = payload
    },

    USER_TIP_CATEGORY(state, payload) {
      state.userTipCategory = payload
    },

    FOOTER_INTRO(state, payload) {
      state.footerIntro = payload
    },

    SUB_MENU(state, payload) {
      state.subMenu = payload
    }
  },
  getters: {
    cmses: state => state.cmses,
    cmsCategories: state => state.cmsCategories,
    selectedCms: state => state.selectedCms,
    selectedCmsSubCategory: state => state.selectedCmsSubCategory,

    bottomMenu: state => state.bottomMenu,

    userTips: state => state.userTips,

    exchangeRates: state => state.exchangeRates,

    userTipCategory: state => state.userTipCategory,

    footerIntro: state => state.footerIntro,

    subMenu: state => state.subMenu
  }
}
